import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Tab, Card, Spinner, Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Block from "../../components/Block/Block";
import { connect } from "react-redux";
import { Image, Icon, Media } from "../../components";
import { toInitials } from "../../utilities";
import { getDriverApi } from "../../services/UserService";
import { updateDriverApi } from "../../services/UserService";
import DataTable from "react-data-table-component";
import { driverridinghistory } from "../../services/UserService";
import { parse, format } from "date-fns";
import { NavLink, Outlet } from "react-router-dom";
import { IoLogoBuffer } from "react-icons/io";
import { FaHistory } from "react-icons/fa";
import Pagination from "../Constant/Pagination";
import {
  FaBus,
  FaRoad,
  FaClock,
  FaExchangeAlt,
  FaRegClock,
} from "react-icons/fa";
// or Fa from 'react-icons/fa'
import { differenceInMinutes } from "date-fns";
import { convertToAMPM } from "../../utilities";
const TripCard = ({ data }) => {
  const { route, shift, bus, start_time, end_time, trip_mode } = data;
  const start = parse(start_time, "HH:mm:ss", new Date());
  const end = parse(end_time, "HH:mm:ss", new Date());
  const duration = differenceInMinutes(end, start);

  return (
    <Card className="shadow-sm mt-3 border rounded-4">
      <Card.Body className="d-flex flex-column">
        <div className="d-flex justify-content-between">
          <span style={{fontSize:'0.95rem',fontWeight:'500'}} className="text-primary  mb-0 d-flex align-items-center">
            <FaRoad className="me-2" />
            {route?.name || "N/A"}
          </span>
          <span
            className={`d-inline-flex align-self-start align-items-center badge rounded-pill ${
              trip_mode === "DROP" ? "text-bg-warning" : "text-bg-success"
            } px-2 py-1`}
          >
            <FaExchangeAlt className="me-1" />
            {trip_mode || "N/A"}
          </span>
        </div>
        <div className="d-flex justify-content-between flex-wrap mt-1">
          <div className="d-flex align-items-center">
            <FaRegClock className="me-1 text-primary" />
            <span className="text-primary fw-medium small">
              Shift:{" "}
            </span>
            <span
              className="ms-1 text-secondary small"
              style={{ fontWeight: "500" }}
            >
              {shift?.name || "N/A"}
            </span>
          </div>

          <div className="d-flex align-items-center">
            <FaBus className="me-1 text-primary" />
            <span className="text-primary fw-medium small">
              Bus:{" "}
            </span>
            <span
              className="ms-1 text-secondary small"
              style={{ fontWeight: "500" }}
            >
              {bus?.number_plate || "N/A"}
            </span>
          </div>
        </div>
        <div className="d-flex flex-wrap align-items-center">
          <FaClock className="me-1 text-primary" />
          <span className="text-primary fw-medium small">
            Time:{" "}
          </span>
          <span
            className="ms-1 text-secondary small"
            style={{ fontWeight: "500" }}
          >
            {data?.start_time ? convertToAMPM(data?.start_time) : "N/A"} -{" "}
            {data?.end_time ? convertToAMPM(data?.end_time) : "N/A"}
          </span>
          <span className="ms-1 text-secondary small">({duration} min)</span>
        </div>
      </Card.Body>
    </Card>
  );
};

function DriverDetailsPage({ userRole }) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isloading, setIsloading] = useState(true);
  const [error, setError] = useState(null);
  const [editloading, setEditloading] = useState(false);
  const [ridinghistory, setRidinghistory] = useState([]);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();
  const [filter, setFilter] = useState({
    page: 1,
    page_size: 8,
  });
  const [editform, setEditform] = useState({
    dl_number: "",
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    is_active: "",
  });
  const [errorform, setErrorform] = useState({
    dl_number: "",
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
  });
  const [modalVisible, setModalVisible] = useState(false);
  const handleToggleModal = () => {
    if (!modalVisible) {
      setEditform({
        dl_number: data?.dl_number || "",
        first_name: data?.user?.first_name || "",
        last_name: data?.user?.last_name || "",
        email: data?.user?.email || "",
        mobile_number: data?.user?.mobile_number || "",
        is_active: data?.user?.is_active || "",
      });
      setErrorform({
        dl_number: "",
        first_name: "",
        last_name: "",
        mobile_number: "",
        email: "",
      });
    }
    setModalVisible((prev) => !prev);
  };
  const fetchUser = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getDriverApi(id);
      setData(response?.data);
    } catch (err) {
      setError(err.message || "An error occurred while fetching data data.");
    } finally {
      setLoading(false);
    }
  };
  // const ridingdata = () => {
  //   setIsloading(true);
  //   driverridinghistory(filter, id)
  //     .then((res) => {
  //       setRidinghistory(res?.data?.results);
  //       setTotal(res.data?.count || 0);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })
  //     .finally(() => {
  //       setIsloading(false);
  //     });
  // };
  useEffect(() => {
    fetchUser();
  }, [id]);
  const editdata = (data) => {
    setEditloading(true);
    updateDriverApi(id, data)
      .then((res) => {
        handleToggleModal();
        fetchUser();
        toast.success("Update Successfully");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setEditloading(false);
      });
  };
  const handlechange = (e) => {
    const { name, value } = e.target;
    setEditform({ ...editform, [name]: value });
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;
    if (name === "email") {
      if (!emailRegex.test(value)) {
        setErrorform((prev) => ({ ...prev, email: "Invalid email format" }));
      } else {
        setErrorform((prev) => ({ ...prev, email: "" }));
      }
    }
    if (name === "mobile_number") {
      if (!phoneRegex.test(value)) {
        setErrorform((prev) => ({
          ...prev,
          mobile_number: "must be 10 digits starting with 6-9",
        }));
      } else {
        setErrorform((prev) => ({ ...prev, mobile_number: "" }));
      }
    }
  };
  const handleedit = () => {
    let valid = true;
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!editform.dl_number.trim()) {
      errors.dl_number = "DL is required";
      valid = false;
    }
    if (!editform.first_name.trim()) {
      errors.first_name = "Firstname is required";
      valid = false;
    }
    if (!editform.last_name.trim()) {
      errors.last_name = "Lastname is required";
      valid = false;
    }
    if (!editform.email.trim()) {
      errors.email = "Email is required";
      valid = false;
    } else if (!emailRegex.test(editform.email)) {
      errors.email = "Invalid email format";
      valid = false;
    }

    if (!editform.mobile_number.trim()) {
      errors.mobile_number = "Mobile number is required";
      valid = false;
    } else if (!phoneRegex.test(editform.mobile_number)) {
      errors.mobile_number = "must be 10 digits starting with 6-9";
      valid = false;
    }
    setErrorform(errors);
    if (valid) {
      editdata(editform);
    }
  };
  const columns = [
    {
      name: "Bus Reg",
      selector: (row) => row.bus_redg_number,
      sortable: true,
      wrap: "true",
    },
    {
      name: "Shift",
      selector: (row) => row.shift,
      sortable: true,
      wrap: "true",
    },
    {
      name: "Trip Type",
      selector: (row) => row.trip_type,
      sortable: true,
      wrap: "true",
    },
    {
      name: "Route",
      selector: (row) => row.route || "N/A",
      sortable: true,
      wrap: "true",
    },
    {
      name: "Date",
      selector: (row) => {
        if (!row.created_at) return "-"; // Handle null/undefined gracefully

        const parsed = parse(row.created_at, "yyyy-MM-dd HH:mm:ss", new Date());
        return format(parsed, "MMM d, yyyy h:mm a"); // e.g., May 14, 2025 4:47 PM
      },
      sortable: true,
      wrap: "true",
    },
  ];
  // useEffect(() => {
  //   ridingdata(filter, id);
  // }, [filter]);
  // const handlePageChange = (page) => {
  //   setFilter((prev) => ({
  //     ...prev,
  //     page: page.selected + 1,
  //   }));
  // };
  const tabs = [
    {
      name: "Riding History",
      icon: <FaHistory className="me-1" />,
      path: `/driver/${id}`,
    },
  ];
  if (loading)
    return (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" />
      </div>
    );

  return (
    <div>
      {/* <Tab.Container defaultActiveKey="tabOne">
        <Block className="mt-2">
          <Tab.Content>
            <Tab.Pane eventKey="tabOne">
              <Card className="card-gutter-md">
                <div className="card-row card-row-lg col-sep col-sep-lg">
                  <div className="card-aside">
                    <Card.Body>
                      <div className="bio-block">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm btn-circle"
                              onClick={() => navigate("/drivers")}
                            >
                              <Icon name="arrow-left"></Icon>
                            </button>
                            <h4 className="bio-block-title mx-3">
                              Driver Details
                            </h4>
                          </div>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={handleToggleModal}
                          >
                            <Icon name="edit" />
                            <span>Edit</span>
                          </Button>
                        </div>

                        <ul className="list-group list-group-borderless small mt-2">
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Full Name:
                            </span>
                            <span className="text">{data?.user?.fullname}</span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Email:
                            </span>
                            <span className="text">{data?.user?.email}</span>
                          </li>

                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Phone No.:
                            </span>
                            <span className="text">
                              {data?.user?.mobile_number}
                            </span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              DL No. :
                            </span>
                            <span className="text">
                              {data?.dl_number || "NA"}
                            </span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Status:
                            </span>
                            <span
                              className={`badge text-bg-${
                                data?.user.is_active
                                  ? "success-soft"
                                  : "danger-soft"
                              }`}
                            >
                              {data?.user.is_active ? "Active" : "Inactive"}
                            </span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Last Login:
                            </span>
                            <span className="text">
                              {data?.user?.last_login}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Card.Body>
                  </div>
                  <div className="card-content col-sep flex-fill">
                    <Card.Body className="p-0">
                      <div className="border-bottom px-3 py-2">
                        <h4>Riding History</h4>
                      </div>
                      <DataTable
                        columns={columns}
                        data={ridinghistory}
                        noDataComponent={
                          <div className="p-2">There are no records found.</div>
                        }
                        progressComponent={
                          <div className="text-center my-4">
                            <Spinner animation="border" variant="primary" />
                          </div>
                        }
                        sortIcon={<div className="data-table-sorter"></div>}
                        pagination
                        paginationPerPage={filter.page_size}
                        progressPending={isloading}
                        highlightOnHover
                        pointerOnHover
                        paginationComponent={(props) => (
                          <div className="data-table-bottom">
                            <Pagination
                              currentPage={filter.page}
                              recordsPage={filter.page_size}
                              dataLength={total}
                              handlePagination={handlePageChange}
                            />
                          </div>
                        )}
                      />
                    </Card.Body>
                  </div>
                </div>
              </Card>
            </Tab.Pane>
          </Tab.Content>
        </Block>
      </Tab.Container> */}
      <div className="card">
        <div className="row px-2">
          <div className="col-12 col-md-4 border-end p-4">
            <div className="bio-block">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm btn-circle"
                    onClick={() => navigate("/drivers")}
                  >
                    <Icon name="arrow-left"></Icon>
                  </button>
                  <h4 className="bio-block-title mx-3">Driver Details</h4>
                </div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={handleToggleModal}
                >
                  <Icon name="edit" />
                  <span>Edit</span>
                </Button>
              </div>

              <ul className="list-group list-group-borderless small mt-2">
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Full Name:
                  </span>
                  <span className="text">{data?.user?.fullname}</span>
                </li>
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Email:
                  </span>
                  <span className="text">{data?.user?.email}</span>
                </li>

                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Phone No.:
                  </span>
                  <span className="text">{data?.user?.mobile_number}</span>
                </li>
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    DL No. :
                  </span>
                  <span className="text">{data?.dl_number || "NA"}</span>
                </li>
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Status:
                  </span>
                  <span
                    className={`badge text-bg-${
                      data?.user.is_active ? "success-soft" : "danger-soft"
                    }`}
                  >
                    {data?.user.is_active ? "Active" : "Inactive"}
                  </span>
                </li>
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Last Login:
                  </span>
                  <span className="text">{data?.user?.last_login}</span>
                </li>
              </ul>
            </div>
            <div className="bio-block">
              <h4 className="bio-block-title mb-1 border-bottom pb-2">
                Active Trips
              </h4>
              {data?.active_trip?.length == 0 ? (
                <div className="text-center my-2">No Trip Found</div>
              ) : (
                data?.active_trip?.map((item, i) => <TripCard data={item} />)
              )}
            </div>
          </div>
          <div className="col-12 col-md-8 p-0">
            <Card.Body className="p-0">
              <div className="border-bottom p-2">
                <ul className="custom-nav1 nav nav-pills">
                  {tabs.map((tab) => (
                    <li className="nav-item" key={tab.path}>
                      <NavLink
                        to={tab.path}
                        end={tab.path === `/driver/${id}`}
                        className={({ isActive }) =>
                          "nav-link rounded-pill" + (isActive ? " active" : "")
                        }
                      >
                        {tab.icon}
                        {tab.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              <Outlet />

              {/* {isloading ? (
                <div className="text-center my-4">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : ridinghistory.length === 0 ? (
                <div className="p-2 text-center">There are no records found.</div>
              ) : (
                <div className="table-responsive pb-2">
                  <table className="table fs-6 mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Bus Reg</th>
                        <th>Shift</th>
                        <th>Trip Type</th>
                        <th>Route</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ridinghistory.map((row, idx) => {
                        let formattedDate = "-";
                        if (row.created_at) {
                          try {
                            const parsed = parse(
                              row.created_at,
                              "yyyy-MM-dd HH:mm:ss",
                              new Date()
                            );
                            formattedDate = format(
                              parsed,
                              "MMM d, yyyy h:mm a"
                            );
                          } catch {
                            formattedDate = "Invalid date";
                          }
                        }

                        return (
                          <tr key={idx}>
                            <td>{row.bus_redg_number || "N/A"}</td>
                            <td>{row.shift || "N/A"}</td>
                            <td>{row.trip_type || "N/A"}</td>
                            <td>{row.route || "N/A"}</td>
                            <td>{formattedDate}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
              {!isloading && ridinghistory.length > 0 && (
                <div className="px-2 border-top">
                  <Pagination
                    currentPage={filter.page}
                    recordsPage={filter.page_size}
                    dataLength={total}
                    handlePagination={handlePageChange}
                  />
                </div>
              )} */}
            </Card.Body>
          </div>
        </div>
      </div>

      <Modal
        show={modalVisible}
        onHide={handleToggleModal}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit</Modal.Title>
        </Modal.Header>

        <Modal.Body className="py-4">
          <div className="row">
            <div className="col-6">
              <label className="form-label">First Name</label>
              <input
                type="text"
                name="first_name"
                value={editform.first_name}
                onChange={handlechange}
                className={`form-control ${
                  errorform.first_name ? "is-invalid" : ""
                }`}
              />
            </div>
            <div className="col-6">
              <label className="form-label">Last Name</label>
              <input
                type="text"
                name="last_name"
                value={editform.last_name}
                onChange={handlechange}
                className={`form-control ${
                  errorform.last_name ? "is-invalid" : ""
                }`}
              />
            </div>
            <div className="col-12">
              <label className="form-label">DL Number</label>
              <input
                type="text"
                name="dl_number"
                value={editform.dl_number}
                onChange={handlechange}
                className={`form-control ${
                  errorform.dl_number ? "is-invalid" : ""
                }`}
              />
            </div>
            <div className="col-12">
              <label className="form-label">Email</label>
              <input
                type="text"
                name="email"
                value={editform.email}
                onChange={handlechange}
                className={`form-control ${
                  errorform.email ? "is-invalid" : ""
                }`}
              />
            </div>
            <div className="col-12">
              <label className="form-label">Phone Number</label>
              <input
                type="text"
                name="mobile_number"
                value={editform.mobile_number}
                onChange={handlechange}
                className={`form-control ${
                  errorform.mobile_number ? "is-invalid" : ""
                }`}
              />
            </div>
            <div
              className="ms-3 mt-2 form-check form-check-sm"
              style={{ fontSize: "0.8rem" }}
            >
              <input
                className="form-check-input"
                type="checkbox"
                name={"is_active"}
                id={"is-active"}
                checked={editform.is_active}
                onChange={(e) =>
                  setEditform({
                    ...editform,
                    is_active: e.target.checked,
                  })
                }
              />
              <label className="form-check-label" htmlFor={"is-active"}>
                Set Active
              </label>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outline-secondary"
            disabled={editloading}
            onClick={handleToggleModal}
          >
            Cancel
          </Button>

          <Button variant="primary" disabled={editloading} onClick={handleedit}>
            {editloading && (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            Update{" "}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.data?.role || "data",
});

export default connect(mapStateToProps)(DriverDetailsPage);
